import { useWindowSize } from "usehooks-ts";

export const useOrientation = () => {
  const { width = 0, height = 0 } = useWindowSize();
  const portrait = height > width;
  return {
    portrait,
    landscape: !portrait
  }
};